/**
 * Shop section Swiper
 */
export class ShopSlider {
  private swiper: unknown = null;

  init(): void {
    if (typeof window.Swiper === 'undefined') return;

    const el = document.querySelector('.shop-slider');
    if (!el) return;

    const SwiperClass = (window as Window & { Swiper: new (el: Element, o: object) => unknown }).Swiper;
    this.swiper = new SwiperClass(el, {
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        544: { slidesPerView: 2, spaceBetween: 24 },
        1200: { slidesPerView: 3, spaceBetween: 24 },
      },
      navigation: {
        nextEl: '.no-shop .swiper-button-next',
        prevEl: '.no-shop .swiper-button-prev',
      },
      pagination: {
        el: '.no-shop .swiper-pagination',
        type: 'progressbar',
      },
    });
  }
}
